import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Copy, Check, Info } from 'lucide-react';

// Conteúdo do modal "Compartilhar Link" — só aparece pra enquete
// pública+rascunho (ver GerenciarEnquetes.js). O link funciona como prévia:
// mostra as perguntas, mas votação/resultado ficam bloqueados até o status
// virar "Publicada" (ver enqueteDinamicaController.js).
const CompartilharLinkModal = ({ enquete }) => {
  const [copiado, setCopiado] = useState(false);
  const link = `${window.location.origin}/e/${enquete.slug}`;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopiado(true);
      toast.success('Link copiado!');
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      toast.error('Não foi possível copiar o link. Copie manualmente.');
    }
  };

  return (
    <div>
      <div className="flex items-start gap-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-4">
        <Info className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
        <p>Essa enquete está em rascunho — quem abrir o link vê as perguntas, mas não consegue votar até o status virar "Publicada".</p>
      </div>

      <label className="block text-xs font-medium text-gray-500 mb-1.5">Link público (prévia)</label>
      <div className="flex items-center gap-2">
        <input
          type="text"
          readOnly
          value={link}
          onFocus={(e) => e.target.select()}
          className="flex-1 min-w-0 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5 truncate"
        />
        <button
          type="button"
          onClick={copiar}
          className={`flex items-center gap-1.5 text-sm font-medium px-3 py-2.5 rounded-lg flex-shrink-0 transition-colors ${
            copiado ? 'bg-emerald-50 text-emerald-700' : 'bg-primary-600 text-white hover:bg-primary-700'
          }`}
        >
          {copiado ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          {copiado ? 'Copiado' : 'Copiar'}
        </button>
      </div>
    </div>
  );
};

export default CompartilharLinkModal;
